import { useMemo } from "react"

import { findChildren } from "shared/lib/treeUtils"
import { ProjectChild } from "shared/types/Project"

import { FAVORITES_PROJECT_ID } from "entities/favorites/api/useFavoriteMutations"
import { useFavorites } from "entities/projects/api/useFavorites"
import { useProjectStore } from "features/project-management/model/useProjectStore"

export function useSelectedFavorites() {
  const { favorites } = useFavorites()
  const { selectedElementIDs } = useProjectStore(FAVORITES_PROJECT_ID)

  return useMemo(
    () => findChildren<ProjectChild>(selectedElementIDs, favorites),
    [selectedElementIDs, favorites]
  )
}
